// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#sales-value-contribution[data-v-47659fe8] {\r\n  width: 100%;\r\n  height: 100%;\n}\n@media (max-width: 768px) {\n[dir] #sales-value-contribution[data-v-47659fe8] {\r\n    margin: 10px;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
